<template lang="html">
  <div class="section">
    <div class="Slide">
      <article>
        <header>
          <p><img src="../assets/images/top/img_blog-header.svg" alt="おやこハグ日記"></p>
          <h2>おやこハグネットは、<br class="visible-sp">日々様々な活動を行っています。</h2>
        </header>
        <ul class="PostSlider">
          <li v-for="post in posts">
            <post :post="post"></post>
          </li>
        </ul>
        <a class="toBlog" v-bind:href="home_url + 'blog/'">≫ ブログ一覧を見る</a>
      </article>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import axios from 'axios';
  import VueAxios from 'vue-axios';
  import $ from 'jquery';
  import 'slick-carousel';
  import Post from './Post';
  import WPURL from '../wp_url';

  const rootURL = WPURL;
  const postsURL = `${WPURL}wp-json/wp/v2/posts?_embed&per_page=5`;

  Vue.use(VueAxios, axios);

  export default {
    name: 'BlogSlide',
    components: {
      Post,
    },

    created() {
      this.getPosts();
    },

    data() {
      return {
        posts: [],
        home_url: rootURL,
      };
    },

    methods: {
      getPosts() {
        Vue.axios.get(postsURL).then((response) => {
          this.posts = response.data;
          const self = this;
          self.initSlick();
        });
      },
      initSlick() {
        // eslint-disable-next-line
        $(function PostSlider() {
          $('.PostSlider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [{
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
                centerMode: false,
              },
            },
            {
              breakpoint: 1023,
              settings: 'unslick',
            }],
          });
        });
      },
    },
  };
</script>

<style lang="scss" src="slick-carousel/slick/slick.scss"></style>
<style lang="scss" src="slick-carousel/slick/slick-theme.scss"></style>
<style lang="scss" scoped>
  @import '../assets/stylesheets/_mixin.scss';
  @import url('http://cdn.jsdelivr.net/jquery.slick/1.6.0/slick.css');
  .Slide {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4.0rem 15px;
    background: #f5ff8e url("../assets/images/top/bg_blog.png") right -12px top -83px no-repeat;
    @include media( md ) {
      width: 100vw;
      height: 100vh;
      padding: 0;
    }
  }
  article {
    @include media( sm ) {
      width: 768px;
    }
    @include media( md ) {
      width: 1000px;
    }
  }
  header {
    margin-bottom: 1.0rem;
    text-align: center;
    p {
      margin: 0;
      padding: 0;
      line-height: 0;
      img {
        text-align: center;
      }
    }
    @include media( md ) {
      display: flex;
      align-items: center;
      margin-bottom: 3.0rem;
      text-align: left;
      p {
        img {
          margin: 0 3.5rem 0 0;
        }
      }
    }
  }
  h2 {
    font-size: 1.7rem;
    line-height: 1.35;
    @include media( md ) {
      font-size: 3.0rem;
    }
  }
  .image {
    text-align: center;
  }
  ul {
    width: 320px;
    margin: 0;
    padding: 0;
    @include media( sm ) {
      width: 768px;
    }
    @include media( md ) {
      display: flex;
      width: 100%;
    }
  }
  li {
    @include media( md ) {
      width: calc( 100% / 5 - 10px );
      padding: 0 5px;
    }
  }
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 2em;
    margin-top: 2em;
    color: #fff;
    font-size: 1.4rem;
    background-color: #c3d600;
    @include media( md ) {
      font-size: 1.8rem;
    }
  }
</style>



// WEBPACK FOOTER //
// BlogSlide.vue?a4b136c0